module.exports = __webpack_public_path__ + "img/back.3acc620f.svg";